import React, { useState, useRef, useEffect } from "react";
import "./AccountDropdown.css";

const AccountDropdown = ({ children, items }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const toggleDropdown = () => {
    console.log("Toggling dropdown, current state:", isOpen);
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item) => {
    console.log("Item clicked:", item.label);
    if (item.onClick) {
      item.onClick();
    }
    setIsOpen(false);
  };

  return (
    <div className="account-dropdown" ref={dropdownRef}>
      <div onClick={toggleDropdown}>
        {children}
      </div>
      {isOpen && (
        <div className="account-dropdown-menu">
          {console.log("Rendering dropdown menu with items:", items)}
          {items.map((item, index) => (
            <button
              key={index}
              className={`account-dropdown-item ${item.dangerous ? 'dangerous' : ''}`}
              onClick={() => handleItemClick(item)}
            >
              {item.icon && <span className="dropdown-icon">{item.icon}</span>}
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccountDropdown;
